import React from 'react';
import './css/WithdrawalConfirmModal.css';

const WithdrawalConfirmModal = ({ isOpen, onClose, onConfirm }) => {
    if (!isOpen) return null;

    return (
        <div className="wcm-modal-overlay" onClick={onClose}>
            <div className="wcm-modal-content" onClick={(e) => e.stopPropagation()}>
                <h3 className="wcm-modal-title">회원탈퇴</h3>
                <p className="wcm-modal-text">부스바월드에서 회원탈퇴됩니다.</p>
                <div className="wcm-modal-actions">
                    <button className="wcm-btn-cancel" onClick={onClose}>취소</button>
                    <button className="wcm-btn-confirm" onClick={onConfirm}>회원탈퇴</button>
                </div>
            </div>
        </div>
    );
};

export default WithdrawalConfirmModal; 